export default "__VITE_ASSET__Bt2csRL4__"